<template>
  <div class="messages-page">
    <div class="page-header">
      <h1>Wiadomości</h1>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Wyszukiwarka konwersacji</h2>
      </div>

      <div class="search-message-container">
        <input
            type="text"
            id="searchMessageInput"
            class="search-message-container__input"
            placeholder="Szukaj konwersacji..."
            v-model="searchMessageInput"
            @keyup.enter="searchMessages"
        >
        <button class="btn-green" @click="searchMessages">Szukaj</button>
        <button
            class="btn-outline"
            @click="() => {
            getMessages();
            searchMessageInput = '';
          }"
        >
          Resetuj
        </button>
      </div>
    </div>

    <div class="section-card" v-if="currentUser && userMessages.length > 0 && currentMessage">
      <div class="messages-container">
        <aside class="messages-container__list">
          <div class="messages-container__list__top-bar">
            <span>
              <span class="messages-container__list__top-bar__num--orange">{{ userMessages.length }}</span>
              &nbsp;konwersacje
            </span>
          </div>

          <div class="messages-container__list__list">
            <div class="messages-container__list__list__item" v-for="(item, index) in userMessages" :key="index">
              <div>
                <b>{{ item.userName }}</b>
                <span :class="item.messages[item.messages.length - 1].from_id !== currentUser.id ? 'messages-container__list__list__item__missed' : ''">
                  {{ item.messages[item.messages.length - 1].content.length > 30 ? item.messages[item.messages.length - 1].content.slice(0, 30) : item.messages[item.messages.length - 1].content }}...
                </span>
              </div>
              <button class="btn-icon" @click="() => setCurrentMessage(item)">
                <img src="@/assets/message-arrow.png" alt="wybierz">
              </button>
            </div>
          </div>
        </aside>

        <section class="messages-container__panel">
          <div class="messages-container__panel__top-bar">
            <router-link :to="`/browse/user/${currentMessage.user_id}`">
              <b>{{ currentMessage.userName }}</b>
            </router-link>
            <span>ostatnia aktywność: <b>{{ currentMessage.messages[currentMessage.messages.length - 1].date }}</b></span>
          </div>

          <div class="messages-container__panel__messages" ref="messageCont">
            <span
                :class="`message ${message.from_id == currentUser.id ? 'messages-container__panel__messages__message--from-me' : 'messages-container__panel__messages__message--to-me'}`"
                v-for="message in currentMessage.messages"
                :key="message.id"
            >
              {{ message.content }}
            </span>
          </div>

          <form class="messages-container__panel__input-bar" @submit="(e) => sendMessage(e)">
            <textarea placeholder="Treść wiadomości" v-model="messageInput" name="message"></textarea>
            <button type="submit" class="btn-send">
              <img src="@/assets/send-icon.png" alt="wyślij">
            </button>
          </form>
        </section>
      </div>
    </div>

    <div class="section-card" v-else>
      <div class="empty-state">
        <p>Brak wyników.</p>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'PrivProfileMessagesVue',
  setup() {
    useMeta({ title: 'wiadomości' });

    return {
      authStore: useAuthStore()
    };
  },
  data() {
    return {
      messagesToMe: [],
      messagesFromMe: [],
      messages: [],
      messageInput: '',
      currentMessage: null,
      userMessages: [],
      searchMessageInput: ''
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 3) {
      this.$router.push('/login');
    }
    this.getMessages();
  },
  methods: {
    getMessages() {
      this.userMessages = [];
      this.currentMessage = null;
      this.messagesFromMe = [];
      this.messagesToMe = [];

      axios.get(`/MessageInBox/${this.currentUser.id}`, authHeader())
          .then((res) => {
            this.messagesToMe = res.data;
            axios.get(`/MessageSend/${this.currentUser.id}`, authHeader())
                .then((resp) => {
                  this.messagesFromMe = resp.data;
                  this.messages = this.messagesToMe.concat(this.messagesFromMe);

                  const fromIds = [];
                  this.messagesToMe.forEach((x) => {
                    if (!fromIds.includes(x.from_id)) {
                      fromIds.push(x.from_id);
                    }
                  });

                  fromIds.forEach((id) => {
                    const userMessages = this.messages
                        .filter((item) => item.from_id == id || item.to_id == id)
                        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

                    const fromUserMessages = this.messages.filter((item) => item.from_id == id);
                    const userName = fromUserMessages.length > 0
                        ? fromUserMessages[fromUserMessages.length - 1].title
                        : 'Konwersacja';

                    this.userMessages.push({
                      user_id: id,
                      messages: userMessages,
                      userName: userName
                    });
                  });

                  if (this.userMessages.length > 0) {
                    this.setCurrentMessage(this.userMessages[0]);
                  }
                });
          });
    },
    setCurrentMessage(item) {
      this.currentMessage = item;
      if (this.currentMessage) {
        this.$nextTick(function() {
          if (this.$refs.messageCont) {
            this.$refs.messageCont.scrollTop = this.$refs.messageCont.scrollHeight;
          }
        });
      }
    },
    sendMessage(e) {
      e.preventDefault();
      if (this.currentMessage && this.messageInput.trim() !== '') {
        const ob = {
          title: this.currentUser.name,
          content: this.messageInput,
          from_id: this.currentUser.id,
          to_id: this.currentMessage.user_id
        };
        axios.post('/Message', ob, authHeader())
            .then((res) => {
              if (String(res.status).charAt(0) === '2') {
                this.messageInput = '';
                this.getMessages();
              }
            });
      }
    },
    searchMessages() {
      if (this.searchMessageInput.trim() === '') {
        this.getMessages();
        return;
      }

      this.userMessages = this.userMessages.filter((item) =>
          item.userName.toLowerCase().includes(this.searchMessageInput.toLowerCase())
      );

      if (this.userMessages.length > 0) {
        this.setCurrentMessage(this.userMessages[0]);
      } else {
        this.currentMessage = null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.messages-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 24px;
  margin-bottom: 20px;
}

.section-card-header h2 {
  margin: 0 0 12px 0;
  font-size: 2rem;
  color: #1f2937;
}

.search-message-container {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.search-message-container__input {
  flex: 1 1 260px;
  min-width: 0;
  border: 1px solid #d1d5db;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 1.4rem;
  outline: none;
}

.search-message-container__input:focus {
  border-color: #10b981;
}

.messages-container {
  display: flex;
  gap: 16px;
  height: 560px;
}

.messages-container__list {
  width: 300px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.messages-container__list__top-bar {
  border-bottom: 1px solid #e5e7eb;
  font-size: 1.5rem;
  padding: 14px 12px;
  background: #f9fafb;
  color: #374151;
}

.messages-container__list__top-bar__num--orange {
  background-color: #f97316;
  color: #fff;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 700;
}

.messages-container__list__list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  overflow-y: auto;
  height: 100%;
}

.messages-container__list__list__item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin: 6px 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  align-items: center;
}

.messages-container__list__list__item div {
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.messages-container__list__list__item div b {
  font-size: 1.4rem;
  color: #1f2937;
}

.messages-container__list__list__item div span {
  font-size: 1.3rem;
  color: #6b7280;
  word-break: break-word;
}

.messages-container__list__list__item__missed {
  font-weight: 700;
  color: #1f2937 !important;
}

.messages-container__panel {
  display: flex;
  flex-direction: column;
  width: calc(100% - 316px);
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.messages-container__panel__top-bar {
  border-bottom: 1px solid #e5e7eb;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 12px;
  background: #f9fafb;
  flex-wrap: wrap;
}

.messages-container__panel__top-bar a {
  text-decoration: none;
}

.messages-container__panel__top-bar b {
  font-size: 1.7rem;
  color: #1f2937;
}

.messages-container__panel__top-bar span {
  color: #6b7280;
}

.messages-container__panel__top-bar span b {
  font-size: 1.4rem;
  color: #374151;
}

.messages-container__panel__messages {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  overflow-y: auto;
  height: 100%;
  background: #fff;
}

.messages-container__panel__messages span {
  max-width: 70%;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 1.4rem;
  line-height: 1.4;
  word-break: break-word;
}

.messages-container__panel__messages__message--to-me {
  align-self: flex-start;
  color: #065f46;
  background: #d1fae5;
}

.messages-container__panel__messages__message--from-me {
  align-self: flex-end;
  color: #9a3412;
  background: #ffedd5;
}

.messages-container__panel__input-bar {
  display: flex;
  width: 100%;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.messages-container__panel__input-bar textarea {
  width: calc(100% - 56px);
  padding: 10px 12px;
  resize: none;
  border: none;
  min-height: 56px;
  font-size: 1.4rem;
  outline: none;
}

.btn-send {
  width: 56px;
  border: none;
  background: #fff;
  cursor: pointer;
  border-left: 1px solid #e5e7eb;
}

.btn-send img {
  width: 20px;
  height: 20px;
}

.btn-green,
.btn-outline {
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.4rem;
  cursor: pointer;
  border: none;
}

.btn-green {
  background: #10b981;
  color: #fff;
}
.btn-green:hover {
  background: #059669;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 8px;
  width: 34px;
  height: 34px;
  cursor: pointer;
}
.btn-icon img {
  width: 14px;
  transform: rotate(180deg);
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
}

.messages-container ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.messages-container ::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 20px;
}
.messages-container ::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 20px;
}
.messages-container ::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

@media (max-width: 900px) {
  .messages-container {
    flex-direction: column;
    height: auto;
  }

  .messages-container__list {
    width: 100%;
    height: 260px;
  }

  .messages-container__panel {
    width: 100%;
    height: 500px;
  }
}

@media (max-width: 480px) {
  .messages-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .btn-green,
  .btn-outline,
  .search-message-container__input {
    width: 100%;
  }
}
</style>